import { render, staticRenderFns } from "./JdsColorPicker.vue?vue&type=template&id=67767f39&scoped=true&"
import script from "./JdsColorPicker.vue?vue&type=script&lang=ts&"
export * from "./JdsColorPicker.vue?vue&type=script&lang=ts&"
import style0 from "./JdsColorPicker.vue?vue&type=style&index=0&id=67767f39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67767f39",
  null
  
)

export default component.exports